<template lang="pug">
  ValidationObserver(ref="form" slim)
    v-row
      v-col(cols="12")
        ValidationProvider(
          vid="balance"
          name="Сума поповнення"
          rules="required|numeric|min_value:1"
          v-slot="{ errors }"
          slim
        )
          v-text-field(
            type="number"
            label="Сума поповнення"
            v-model="balance"
            placeholder="Введіть суму поповнення"
            :error-messages="errors"
            outlined
          )
          p {{ $t('Sms left') }}: {{ estimatedSmsCount }}
      v-col(cols="12" class="text-center pt-0")
        v-btn(
          class="pay__button"
          color="black"
          @click="payViaCart"
          :loading="cartLoader"
          :disabled="cartLoader || invoiceLoader"
          block
          dark
        )
          | {{ $t('Pay by card') }}
          e-svg-icon(size="lg" class="ml-3") mastercard
          e-svg-icon(size="lg" class="ml-3") visa-white
        v-btn(
          class="pay__button mt-4"
          color="black"
          @click="payViaInvoice"
          :loading="invoiceLoader"
          :disabled="invoiceLoader || cartLoader"
          block
          dark
        )
          | {{ $t('Create an invoice') }}
          e-svg-icon(size="lg" class="ml-5") invoice
</template>

<script>
import ESvgIcon from '~/components/elements/icons/e-svg-icon'
import TOrmFields from '~/components/templates/orm/t-orm-fields'

import { pricePerSms } from '~/const/global'
import contentDialog from '~/mixins/dialogs/contentDialog'

import SmsBilling from '~/models/sms/SmsBilling'
import SmsInvoice from '~/models/sms/SmsInvoice'

export default {
  components: { ESvgIcon, TOrmFields },
  mixins: [contentDialog],
  props: {
    context: {
      type: String,
      default: 'create',
      validator: (value) => {
        return ['create', 'update'].includes(value)
      }
    }
  },
  data: () => ({
    balance: null,
    editedItem: {},
    invoiceLoader: false,
    cartLoader: false
  }),
  computed: {
    estimatedSmsCount () {
      return (this.balance) ? Math.floor(this.balance * 100 / pricePerSms) : 0
    }
  },
  methods: {
    async isValidFrom () {
      return await this.$refs.form.validate()
    },
    async payViaInvoice () {
      if (!await this.isValidFrom()) {
        return
      }

      try {
        this.invoiceLoader = true
        const invoice = await SmsInvoice.api().generateSmsInvoice({
          amount: parseInt(this.balance * 100)
        })

        this.$notification.success('Рахунок сформовано')

        const pdf = await SmsInvoice.api().getSmsInvoicePdf(this._.get(invoice, 'response.data.id'))
        const blob = new Blob([this._.get(pdf, 'response.data', '')], { type: 'application/pdf' })

        window.open(URL.createObjectURL(blob), '_blank')
        await this.contentDialog.close()
      } catch (e) {
        this.$handlers.error(e, this)
      } finally {
        this.invoiceLoader = false
      }
    },
    async payViaCart () {
      if (!await this.isValidFrom()) {
        return
      }

      try {
        this.cartLoader = true
        const response = await SmsBilling.api().post(SmsBilling.$routes[SmsBilling.entity].generatePaymentLink(), {
          lang: 'ua',
          amount: parseInt(this.balance * 100)
        }, { save: false })

        const shortLink = this._.get(response, 'response.data.url')

        if (shortLink) {
          window.open(shortLink, '_blank')
        }

        await this.contentDialog.close()
      } catch (e) {
        this.$handlers.error(e, this)
      } finally {
        this.cartLoader = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
//
</style>
